import {createSvgIcon} from '../create-svg-icon';

export const StraightIcon = createSvgIcon(
  <path d="M11 6.83 9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z" />
, 'StraightOutlined');
